export default __webpack_public_path__ + "static/media/rgs_small.bc3cecba.jpg";